<template>
  <v-container
    fluid
    class="py-5 px-5 py-sm-10 px-sm-10 fill-height align-start"
  >
    <!--page heading-->
    <v-row>
      <v-col cols="12" class="text-start">
        <span class="text-h5 font-weight-medium textLight--text">
          {{ $t("invoice.invoice") }}
        </span>
      </v-col>
    </v-row>

    <!--invoice generate section-->
    <v-row>
      <v-col cols="12" class="text-start">
        <InvoiceTrainingRegistrationSelector
          v-if="havePermissionGenerateInvoice"
          @onGenerate="refreshInvoiceTable"
        />
      </v-col>
    </v-row>

    <!--invoice downloads section-->
    <v-row class="mt-10">
      <v-col>
        <InvoicesTable
          v-if="havePermissionDownloadInvoice"
          ref="invoicesTable"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import InvoiceTrainingRegistrationSelector from "@/app/invoices-module/components/InvoiceTrainingRegistrationSelector";
import InvoicesTable from "../components/InvoicesTable";

import { hasPermission } from "@/app/user-module/helpers/authHelper";

export default {
  name: "InvoicesPage",
  components: { InvoiceTrainingRegistrationSelector, InvoicesTable },
  data() {
    return {
      selectedTab: 0,
    };
  },
  computed: {
    havePermissionGenerateInvoice() {
      return hasPermission({
        currentRole: this.$store.state.authenticatedUserRole,
        currentPermissions: this.$store.state.authenticatedUserPermissions,
        requiredPermission: ["GENERATE_INVOICE"],
        restrictOrganizationManager:
          this.$store.state.authenticatedUser?.isOrganizationManager,
      });
    },
    havePermissionDownloadInvoice() {
      return hasPermission({
        currentRole: this.$store.state.authenticatedUserRole,
        currentPermissions: this.$store.state.authenticatedUserPermissions,
        requiredPermission: ["DOWNLOAD_INVOICE"],
        restrictOrganizationManager:
          this.$store.state.authenticatedUser?.isOrganizationManager,
      });
    },
  },
  methods: {
    refreshInvoiceTable() {
      this.$refs.invoicesTable.resetFiltersAndRefresh();
    },
  },
};
</script>
